/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconNotificationsActiveFilled/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconNotificationsActiveFilled({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconNotificationsActiveFilled",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconNotificationsActiveFilled.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-Z3bK92': alignSelf,'--mt-2-Z3bK92': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z3bK92': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z3bK92': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z3bK92': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z3bK92': opacity,'--w-10-Z3bK92': typeof width === 'number' ? `${width}px` : width,'--h-11-Z3bK92': typeof height === 'number' ? `${height}px` : height,'--a-7-Z3bK92': isAnimated ? animation : "none",'--sd-8-Z3bK92': isAnimated ? strokeDashoffset : 0,'--sd-9-Z3bK92': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconNotificationsActiveFilled.SvgPath"
  data-view-path={viewPath}
 d="M7.58 4.08L6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2a8.445 8.445 0 013.55-6.42zm12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43a8.495 8.495 0 013.54 6.42zM18 11c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2v-5zm-6 11c.14 0 .27-.01.4-.04.65-.14 1.18-.58 1.44-1.18.1-.24.15-.5.15-.78h-4c.01 1.1.9 2 2.01 2z"
 style={{'--f-12-Z3bK92': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}